import { render } from "./SellCoin.vue?vue&type=template&id=13f5bb3c&scoped=true"
import script from "./SellCoin.vue?vue&type=script&lang=js"
export * from "./SellCoin.vue?vue&type=script&lang=js"

import "./SellCoin.vue?vue&type=style&index=0&id=13f5bb3c&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f5bb3c"]])

export default __exports__